

module.exports = [
  {
    id: 0,
    img: '../../../assets/images/snapp-services/bike.svg',
    title: 'اسنپ! باکس و اسنپ!‌ بایک',
    titleIntro: 'پیک‌ موتوری و تاکسی موتوری',
    desc: 'سرویس «اسنپ!‌باکس» برای جابه‌جایی بسته و مرسولات و سرویس «اسنپ!‌بایک» یا تاکسی موتوری برای جابه‌جایی در مراکز شلوغ و پُر ترافیک بهترین راهکار است.',
    link: 'https://snapp.ir/blog/using-snappbox/',
    linkAble: true,
  },
  {
    id: 1,
    img: '../../../assets/images/snapp-services/fintech.svg',
    title: 'اسنپ! ‌بورس',
    titleIntro: 'بورس و سرمایه‌گذاری',
    desc: 'با استفاده از این سرویس می‌توانید آنلاین در سامانه سجام ثبت‌نام کنید، احزار هویت سجام را به صورت غیرحضوری انجام دهید و اقدام به مشاهده و فروش سهام عدالت کنید.',
    link: '',
    linkAble: false,
  },
  {
    id: 2,
    img: '../../../assets/images/snapp-services/cab.svg',
    title: 'اسنپ! ',
    titleIntro: 'درخواست خودرو',
    desc: 'اسنپ! اولین و بزرگ‌ترین تاکسی اینترنتی ایران است که برای جابه‌جایی در شهرهای بزرگ و کوچک ایران آماده خدمت‌رسانی به شماست.',
    link: '',
    linkAble: false,
  },
  {
    id: 3,
    img: '../../../assets/images/snapp-services/charity.svg',
    title: 'نیکوکاری',
    titleIntro: 'حمایت از کادر درمان و بیماران کرونا',
    desc: 'با استفاده از سرویس نیکوکاری می‌توانید بدون واسطه، کمک‌های خود را برای «مجمع خیرین سلامت کشور» واریز کنید تا نیازهای کادر درمان و بیماران کرونا تامین شود.',
    link: '',
    linkAble: false,
  },
  {
    id: 4,
    img: '../../../assets/images/snapp-services/club.svg',
    title: 'اسنپ! ‌کلاب',
    titleIntro: 'باشگاه مشتریان اسنپ!',
    desc: 'باشگاه مشتریان اسنپ! با ارائه امکانات ویژه از همراهی کابران وفادار خود با جوایز و تخفیف‌های هیجان‌‌انگیز قدردانی می‌کند. همین حالا برای دریافت جوایز اقدام کنید.',
    link: '',
    linkAble: false,
  },
  {
    id: 5,
    img: '../../../assets/images/snapp-services/doctor.svg',
    title: 'اسنپ! ‌دکتر',
    titleIntro: 'مشاوره پزشکی',
    desc: 'سرویس «پزشک و مشاور» اسنپ! امکان استفاده از مشاوره آنلاین پزشکی را در تمام حوزه‌ها از قبیل روانشناسی، روانپزشکی، کرونا، بیماری‌های داخلی و غیره فراهم می‌کند.',
    link: '',
    linkAble: false,
  },
  {
    id: 6,
    img: '../../../assets/images/snapp-services/food.svg',
    title: 'اسنپ! ‌فود',
    titleIntro: 'سفارش آنلاین غذا',
    desc: 'اسنپ!‌فود اولین و بزرگ‌ترین سامانه سفارش آنلاین غذا در ایران است و علاوه بر سفارش غذا خدمات سفارش آنلاین کیک، شیرینی و سوپرمارکت را هم برای شما فراهم می‌کند.',
    link: '',
    linkAble: false,
  },
  {
    id: 7,
    img: '../../../assets/images/snapp-services/market.svg',
    title: 'اسنپ! ‌مارکت',
    titleIntro: 'خرید از هایپراستار و سوپرمارکت‌',
    desc: 'با اسنپ!‌مارکت دیگر دغدغه خرید انواع محصولات سوپرمارکتی را ندارید؛ امکان خرید از «هایپراستار» در برخی از شهرها و خرید آنلاین از سوپرمارکت‌های اطراف.',
    link: '',
    linkAble: false,
  },
  {
    id: 8,
    img: '../../../assets/images/snapp-services/pay.svg',
    title: 'اسنپ! ‌پرداخت',
    titleIntro: 'خرید شارژ سیم‌کارت و بسته اینترنت، پرداخت قبض',
    desc: 'با اسنپ! به راحتی سیم‌کارت خود (ایرانسل، همراه اول، رایتل یا آذرتل) را شارژ کنید، بسته اینترنتی بخرید و یا قبض‌های خود را پرداخت کنید.',
    link: '',
    linkAble: false,
  },
  {
    id: 9,
    img: '../../../assets/images/snapp-services/q.svg',
    title: 'اسنپ! کیو',
    titleIntro: 'بازی',
    desc: 'برای سرگرمی می‌توانید از سرویس «بازی» اسنپ! استفاده کنید و هر روز با شرکت در بازی‌های مختلف به صورت فردی یا با دوستان خود جایزه ببرید.',
    link: '',
    linkAble: false,
  },
  {
    id: 10,
    img: '../../../assets/images/snapp-services/trip.svg',
    title: 'اسنپ! ‌تریپ',
    titleIntro: 'خرید بلیت، رزرو هتل و اقامتگاه',
    desc: 'با استفاده از اسنپ! برای سفر خود به طور کامل برنامه‌ریزی کنید؛ خرید بلیت هواپیما، قطار و اتوبوس به همراه رزرو هتل و اقامتگاه اقتصادی.',
    link: '',
    linkAble: false,
  },
  {
    id: 11,
    img: '../../../assets/images/snapp-services/van.svg',
    title: 'اسنپ! ‌وانت',
    titleIntro: 'درخواست آنلاین وانت',
    desc: 'برای حمل‌ونقل وسایل حجیم و سنگین (تا ۵۰۰ کیلوگرم) به راحتی از سرویس «وانت» اسنپ! استفاده کنید.',
    link: '',
    linkAble: false,
  }
];



// WEBPACK FOOTER //
// ./src/js/config/SnappServicesContent.js